export const MAILING_API = '/api/dashboard/customer/emails'

export const MAILING_RECIPIENT_API = '/api/dashboard/customer/email-recipients'
